const getDefaultValue = defaultValues => {
  const selectedValue = defaultValues.find(element => element.selected === true)
  if (selectedValue) {
    return selectedValue.value
  }
  return null
}

const mapFieldToState = (fieldType, defaultValue) => {
  return fieldType !== 'checkbox' ? defaultValue : ''
}

export const mapFormFieldsJSON = (json) => {
  const newState = {}

  json.tabs.forEach(tab => {
    const tabName = tab.tag
    const fieldObject = {}

    tab.formFields.forEach(formfield => {
      formfield.formGroups.forEach(formGroup => {
        formGroup.fields.forEach(field => {
          const { id, fieldType, defaultValue: defaultValues } = field
          let defaultValue = defaultValues

          if (Array.isArray(defaultValues)) {
            defaultValue = getDefaultValue(defaultValues)
          }

          const fieldData = mapFieldToState(fieldType, defaultValue)
          if (id) {
            fieldObject[id] = fieldData
          }

          field.subFields.forEach(subfield => {
            subfield.fields.forEach(sField => {
              const { id, fieldType, defaultValue: defaultValues } = sField
              let defaultValue = defaultValues

              if (Array.isArray(defaultValues)) {
                defaultValue = getDefaultValue(defaultValues)
              }

              const fieldData = mapFieldToState(fieldType, defaultValue)
              fieldObject[id] = fieldData
            })
          })
        })
      })
    })
    newState[tabName] = fieldObject
  })

  return newState
}
